module.exports = __webpack_public_path__ + "static/media/po-reman-2-3.4d63b753.png";